module.exports = __webpack_public_path__ + "static/media/corporate.d051b791.png";